import loadable from "@loadable/component";

export const LoadableRenderer = loadable(() => import("./Renderer"));
